

export function timeAgo(time) {
    const date = new Date(time);
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) {
        return `${days} 天前`;
    } else if (hours > 0) {
        return `${hours} 小时前`;
    } else if (minutes > 0) {
        return `${minutes} 分钟前`;
    } else {
        return `${seconds} 秒前`;
    }
}

export function formatDate(isoDateString) {
    const date = new Date(isoDateString);
    const formatter = new Intl.DateTimeFormat('zh-CN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false // Uses 24-hour time
    });
    try {
        return formatter.format(date);
    } catch (error) {
        return isoDateString;
    }
  }